import YICUClassPage from "./YICUClassPage";

const CONTENT = {
  individualNominees: [
    { name: "Alonnah Wallace", image: "/images/YICU/2019/Al-Wallace.png" },
    { name: "Amara Sheppard", image: "/images/YICU/2019/Amara-Sheppard.jpg" },
    { name: "Amber Waninger", image: "/images/YICU/2019/Amber-Waninger.jpg" },
    { name: "Anthony Miller", image: "/images/YICU/2019/Kathy-Weinzierl.jpg" },
    { name: "Bradley Bruhl", image: "/images/base/Contact-1.png" },
    { name: "Brady Veal", image: "/images/YICU/2019/Eric-Veal.jpg" },
    { name: "Camryn Restivo", image: "/images/YICU/2019/Camryn-Restivo.png" },
    { name: "Cas Kerfoot", image: "/images/YICU/2019/casper-kerfoot.jpg" },
    { name: "Gavin Cunningham", image: "/images/YICU/2019/Gavin-Vlogs.jpg" },
    { name: "Heather Dawson", image: "/images/YICU/2019/Heather-Dawson.jpg" },
    { name: "Imani Sanchez", image: "/images/YICU/2019/Imani-Sanchez.jpg" },
    { name: "Isha Gollapudi", image: "/images/YICU/2019/Isha-Kiran-Gollapudi.jpg" },
    { name: "Jacob Henderson", image: "/images/YICU/2019/Jacob-Henderson.jpg" },
    { name: "Jasmyn Jordan", image: "/images/YICU/2019/Jasmyn-Jordan.jpg" },
    { name: "Jennie Mulholland", image: "/images/YICU/2019/Jennie-Mulholland.jpg" },
    { name: "Jonah Prokes", image: "/images/YICU/2019/Kari.png" },
    { name: "Jude Lahr", image: "/images/YICU/2019/judie-Jude-Elisabeth.jpg" },
    { name: "Kaitlynn Whitecotton", image: "/images/YICU/2019/Kaitlynn-Whitecotton.png" },
    { name: "Kyleigh McBride", image: "/images/YICU/2019/Kyleigh-McBride.jpg" },
    { name: "MacKenna Gravel", image: "/images/YICU/2019/MacKenna-Gravel.jpg" },
    { name: "Madalyn Schmitt", image: "/images/YICU/2019/Madalyn-Schmitt.jpg" },
    { name: "Madi Ching", image: "/images/YICU/2019/me12-Madi-Ching.jpg" },
    { name: "Rachel Dawson", image: "/images/YICU/2019/Rachel-Dawson.jpg" },
    { name: "Reace Erbe", image: "/images/YICU/2019/erbman.jpg" },
    { name: "Savannah Harpel", image: "/images/YICU/2019/Savannah-H.jpg" },
    { name: "Shreenija Daggavolu", image: "/images/YICU/2019/ShreenijaReddy-Daggavolu.png" },
    { name: "Sriya Darsi", image: "/images/YICU/2019/Sriya-Darsi.jpg" },
    { name: "Sunny Shaheen", image: "/images/YICU/2019/Sunny-Shaheen.jpg" },
    { name: "Tristan Bixby", image: "/images/YICU/2019/Tristan-Bixby.jpg" },
    { name: "Venkatesh Shenoy", image: "/images/YICU/2019/V-Shenoy.jpg" },
    { name: "Wah Chook", image: "/images/YICU/2019/Wah-Chook.png" },
    { name: "Yash Gollapudi", image: "/images/YICU/2019/Yash-Gollapudi.jpg" },
  ],
  teamNominees: [
    { name: "Olympia Pacesetters 4-H Club", image: "/images/YICU/2019/Carolyn-Hansen.jpg", bio: "A youth-led community service club committed to fighting hunger and fostering servant leadership in Central Illinois." },
  ],
};

export default function Yicu2019() {
  return <YICUClassPage year="2019" content={CONTENT} />;
}